import { MobilePassData } from "../base/n3xus/types";

// write an events catalogue for the claim webcomponent
const CLAIM_EVENT_CLAIMING = 'fp-claim-claiming'
const CLAIM_EVENT_CLAIMED = 'fp-claim-claimed'
const CLAIM_EVENT_MODAL_OPEN = 'fp-claim-modal-open'
const CLAIM_EVENT_MODAL_CLOSE = 'fp-claim-modal-close'

export enum ClaimEvents {
  Claiming = CLAIM_EVENT_CLAIMING,
  Claimed = CLAIM_EVENT_CLAIMED,
  ModalOpen = CLAIM_EVENT_MODAL_OPEN,
  ModalClose = CLAIM_EVENT_MODAL_CLOSE
}

export type FPClaiming = CustomEvent<Record<PropertyKey, string | null | boolean | undefined | Array<MobilePassData>>>;
declare global {
    interface GlobalEventHandlersEventMap {
        [ClaimEvents.Claiming]: FPClaiming;
    }
}

export type FPClaimed = CustomEvent<Record<PropertyKey, string | null | boolean | undefined | Array<MobilePassData>>>;
declare global {
    interface GlobalEventHandlersEventMap {
        [ClaimEvents.Claimed]: FPClaimed;
    }
}

export type FPClaimModalOpen = CustomEvent<Record<PropertyKey, never>>;
declare global {
    interface GlobalEventHandlersEventMap {
        [ClaimEvents.ModalOpen]: FPClaimModalOpen;
    }
}

export type FPClaimModalClose = CustomEvent<Record<PropertyKey, never>>;
declare global {
    interface GlobalEventHandlersEventMap {
        [ClaimEvents.ModalClose]: FPClaimModalClose;
    }
}
